import { render, staticRenderFns } from "./UpsellCompanyFilters.vue?vue&type=template&id=53514786&"
import script from "./UpsellCompanyFilters.vue?vue&type=script&lang=js&"
export * from "./UpsellCompanyFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports